function attach_to_top(main_ele, attach_ele, animate) {
    var main_width = main_ele.outerWidth();
    var attach_width = attach_ele.outerWidth();
    if (animate) {
        attach_ele.animate({top: main_width / 2 - attach_width / 2}, 500);
    } else {
        attach_ele.css('top', main_width / 2 - attach_width / 2);
    }
}

function hide_navigation_buttons_bottom() {
    var vehicle_navigation_buttons_wrapper_div = $('#vehicle-navigation-buttons-wrapper-div');
    var vehicle_navigation_buttons_div = $('#vehicle-navigation-buttons-div');
    vehicle_navigation_buttons_wrapper_div.animate({bottom: -1 * parseInt(vehicle_navigation_buttons_div.outerHeight(true))}, 500, function(){
        vehicle_navigation_buttons_div.addClass('invisible');
    });

}

function show_navigation_buttons_bottom() {
    var vehicle_navigation_buttons_wrapper_div = $('#vehicle-navigation-buttons-wrapper-div');
    var vehicle_navigation_buttons_div = $('#vehicle-navigation-buttons-div');
    vehicle_navigation_buttons_wrapper_div.animate({bottom: 0}, 500);
    vehicle_navigation_buttons_div.removeClass('invisible');
}

function handle_navigation_buttons_toggle_bottom(event) {
    var vehicle_navigation_buttons_wrapper_div = $('#vehicle-navigation-buttons-wrapper-div');

    if (vehicle_navigation_buttons_wrapper_div.hasClass('vehicle-navigation-buttons-reveal')) {
        vehicle_navigation_buttons_wrapper_div.removeClass('vehicle-navigation-buttons-reveal');
        hide_navigation_buttons_bottom();
    } else {
        vehicle_navigation_buttons_wrapper_div.addClass('vehicle-navigation-buttons-reveal');
        show_navigation_buttons_bottom();
    }
}

function handle_navigation_load() {
    var vehicle_navigation_buttons_wrapper_div = $('#vehicle-navigation-buttons-wrapper-div');
    var vehicle_navigation_buttons_grab_div = $('#vehicle-navigation-buttons-grab-div');

    if (vehicle_navigation_buttons_wrapper_div.length) {
        $(document).on('click', '.hide-nav-link', function (event) {
            if ($(document).width() <= 992) {
                hide_navigation_buttons_bottom();
            }
        });

        //Mousedown is used incase they drag on mobile
        $(document).on('mousedown', '.vehicle-navigation-toggle', handle_navigation_buttons_toggle_bottom);
    }
}

function handle_navigation_resize() {
    var vehicle_navigation_buttons_wrapper_div = $('#vehicle-navigation-buttons-wrapper-div');
    var vehicle_navigation_buttons_grab_div = $('#vehicle-navigation-buttons-grab-div');

    if (vehicle_navigation_buttons_wrapper_div.length) {
        if ($(document).width() <= 992) {
            vehicle_navigation_buttons_wrapper_div.addClass('sticky-bottom-panel');
            vehicle_navigation_buttons_wrapper_div.css('bottom', -1 * parseInt(vehicle_navigation_buttons_wrapper_div.outerHeight(true)));
            vehicle_navigation_buttons_grab_div.removeClass('hide');
            vehicle_navigation_buttons_grab_div.css('width', $(document).outerWidth() / 3);

            attach_to_top(vehicle_navigation_buttons_wrapper_div, vehicle_navigation_buttons_grab_div);
            hide_navigation_buttons_bottom();
        } else {
            vehicle_navigation_buttons_wrapper_div.removeClass('sticky-bottom-panel');
            vehicle_navigation_buttons_wrapper_div.css('bottom', "");
            vehicle_navigation_buttons_grab_div.addClass('hide');
            vehicle_navigation_buttons_grab_div.css('width', "").css('top', "");

            show_navigation_buttons_bottom();
        }
    }
}

//This activates after images are loaded
$(window).on("load", handle_navigation_load);
$(window).on("load", handle_navigation_resize);

$(window).on("resize", debounce(handle_navigation_resize, 200));